import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { BookingPageFilterElementGen } from "@/services/booking/v1/data-contracts";
import { MrfiktivPageFilterElementGen } from "@/services/mrfiktiv/v1/data-contracts";
import { SignPageFilterElementGen } from "@/services/sign/v1/data-contracts";
import { ThgPageFilterElementGen } from "@/services/thg/v1/data-contracts";
import { IPaginationFilterListElement } from "@/store/modules/base-pagination.store";

class PageFilterElementBase
  implements
    MrfiktivPageFilterElementGen,
    ThgPageFilterElementGen,
    SignPageFilterElementGen,
    BookingPageFilterElementGen {
  key: string;
  operation?: PageFilterOperationEnum;
  value: string;

  /**
   * A copy of the filter option determining what the user sees when setting the filter
   * This is stored here to allow for a better mapping between filter element that is sent to backend and filter option used in frontend
   * in some circumstances the key is not sufficient to map between filter element and filter option (e.g. custom field values have same key in ticket)
   */
  filterOption?: IPaginationFilterListElement;

  get dto() {
    return { key: this.key, operation: this.operation, value: this.value };
  }

  constructor(filter?: Partial<MrfiktivPageFilterElementGen | IPageFilterElement>) {
    this.key = filter?.key ?? "";
    this.operation = filter?.operation as PageFilterOperationEnum;
    this.value = filter?.value ?? "";
    this.filterOption = (filter as IPageFilterElement)?.filterOption;
  }
}

type IPageFilterElement = PageFilterElementBase;
const PageFilterElement = PageFilterElementBase;

export { IPageFilterElement, PageFilterElement };
